import { createContext } from 'react'
import { BrandColors } from './BrandColors.type'

const MozgotekaContext = createContext<BrandColors | null>(null)

export default MozgotekaContext
